import React from 'react';
import logo from "../../images/PixelGameLogo.png";
import menu from "../../images/Header/menu.svg";
import { Link } from "react-scroll";

const HeaderContent = ({openModal, openMenu}) => {
    return (
        <header>
            <div className="container header-container">
                <div className="header-nav">
                    <img className='header-logo' src={logo} alt="Pixel Game"/>
                    <nav>
                       <button onClick={() => openMenu()} className='header-menu'><img src={menu} alt=""/></button>

                        <ul className='nav-list'>
                            <li className="nav-item">
                                <Link  to="section1" smooth={true} duration={500}  href="#">Комплекти</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="section2" smooth={true} duration={500} href="#">Каталог ігор</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="section3" smooth={true} duration={500} href="#">Доставка</Link>
                            </li>
                            <li className="nav-item">
                                <Link  to="section4" smooth={true} duration={500} href="#">FAQ</Link>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div className="header-row">
                    <h1 className='header-heading'>
                        Оренда ігрових консолей <br/>
                        <span className='consoles-name'>PlayStation, <br/> Xbox </span>
                        <span style={{color: 'red'}}>від <span className='numbers'>1330</span></span> гривень на <span
                        style={{borderBottom: '3px solid red'}}>тиждень</span>
                    </h1>
                    <p className='header-desc'><span style={{fontWeight: '700'}}>Доставимо безкоштовно</span> до дверей
                    </p>
                    <button onClick={() => openModal()} className='red-btn header-red-btn'>Отримати консоль</button>
                </div>
            </div>
        </header>

    );
};

export default HeaderContent;